import { memo, useMemo } from 'react'
import { useFormState } from 'react-final-form'
import cn from 'classnames'
import { IOrderCreateFormData } from 'modules/order/types/orderGuestCreateTypes'
import IconAlert from 'remixicon/icons/System/alert-fill.svg?react'
import { OrderCargoInfo, OrderCreateCargo } from 'schema'

import { MAX_PALLETE_HEIGHT_IN_CENTIMETER } from '../constants'

interface IProps {
  className?: string
}

export const OrderCargoHeightLimitWarning = memo<IProps>(function OrderCargoHeightLimitWarning({ className }) {
  const { values } = useFormState<IOrderCreateFormData>()
  const { cargoType, cargo, departurePoint, destinationPoint, customer } = values
  const hasSpecialCargoLimits = customer?.hasSpecialCargoLimits

  const isShowWarning = useMemo(() => {
    if (![departurePoint, destinationPoint].some((point) => point?.terminalId && point?.isCourier)) {
      return false
    }
    if (!cargoType) {
      return false
    }

    if (cargoType === OrderCargoInfo.type.SEPARATE && cargo?.length) {
      return cargo.some(
        (cargoItem) =>
          cargoItem.type === OrderCreateCargo.type.PALLET && cargoItem.palletHeight > MAX_PALLETE_HEIGHT_IN_CENTIMETER
      )
    }

    return false
  }, [cargo, cargoType, departurePoint, destinationPoint])

  const message = useMemo(
    () => (
      <>
        Забор/доставка груза будет выполнена отдельным транспортным средством, т.к. высота груза превышает{' '}
        {MAX_PALLETE_HEIGHT_IN_CENTIMETER} см, обратитесь за расчётом стоимости дополнительных услуг{' '}
        {hasSpecialCargoLimits ? 'к своему проектному менеджеру' : 'в службу поддержки'}
      </>
    ),
    [hasSpecialCargoLimits]
  )

  return isShowWarning ? (
    <div
      className={cn(className, 'mt-2 grid grid-cols-[auto_1fr] items-start gap-x-4 rounded bg-attention-container p-3')}
    >
      <IconAlert className="text-on-attention-container" containerSize="nm" size="xs" />
      <div>{message}</div>
    </div>
  ) : null
})
